import { render } from "./vminipluswecomedit.vue?vue&type=template&id=2c6f8acc&scoped=true"
import script from "./vminipluswecomedit.vue?vue&type=script&lang=js"
export * from "./vminipluswecomedit.vue?vue&type=script&lang=js"

import "./vminipluswecomedit.vue?vue&type=style&index=0&id=2c6f8acc&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6f8acc"]])

export default __exports__